import $ from 'jquery';
import mapboxgl from 'mapbox-gl';
import * as turf from '@turf/turf';
import { viewport } from '../utilities/viewport';
import { normalize } from '../utilities/normalize';
import { escapeRegExp } from '../utilities/escaperegexp';
import { Promise } from 'bluebird';

const abbreviations = {
  NSW: 'New South Wales',
  WA: 'Western Australia',
  ACT: 'Australian Capital Territory',
  NT: 'Northern Territory',
  QLD: 'Queensland',
  SA: 'South Australia',
  TAS: 'Tasmania',
  VIC: 'Victoria',
  NAT: 'National',
};
const auCenter = [133.0, -27.5];
const auBounds = [
  [112.0, -44.0],
  [154.0, -9.0],
];
const stateCentroids = {
  NSW: [145.612793, -32.840233],
  WA: [122.805176, -26.760321],
  ACT: [149.012375, -35.473469],
  NT: [133.550964, -20.491411],
  QLD: [142.702789, -21.917574],
  SA: [136.209152, -31.000233],
  TAS: [146.315918, -42.640079],
  VIC: [143.8146, -38.0701],
  NAT: [133.0 , -25.0],
};
const nationalProjects = [];

const isOnMobile = viewport().width <= 760;
let mapFirstLoad = 0;
let projectsGeojson = {
  type: 'FeatureCollection',
  features: [],
};
let initialProjectsGeojson;
const clusterLeavesGeojson = {
  type: 'FeatureCollection',
  features: [],
};
let isClusterLeavesExpanded = false;
const projectPopups = {}; // all individual project popups
let projectPopupsOnScreen = {};
let stateZoomThreshold;
const singleClusterZoomThreshold = 6;
const statePopups = {}; // all state popups
const stateData = {
  NSW: 0,
  WA: 0,
  ACT: 0,
  NT: 0,
  QLD: 0,
  SA: 0,
  TAS: 0,
  VIC: 0,
  NAT: 0,
};
const detailPopup = new mapboxgl.Popup({
  anchor: 'bottom',
  offset: {
    bottom: [0, -2.5],
  },
  className: 'detail-popup',
  maxWidth: '978px',
});
let previousMapCenter;
let previousMapZoom;

var getMapJsonData = new Promise((resolve, reject) => {
  if (!$('#map').length) {
    return;
  }


var hiddenIdFilteredResult=new Array; 
var hiddenIdNotInResult=new Array; 

 $( ".hidden-ipl-markup-nid" ).each(function() {
  if ($(this)[0]!=="undefined") {
   hiddenIdFilteredResult.push(Number($( this )[0].innerHTML));
  }
});

  $.getJSON('/ipl-map/map-contents.json', function(data) {
    let dataSize = data.length;
    $.each(data, function(index, data) {
      const locations = data.locations.split(',').map((s) => s.trim());
      const states = data.state.split(',').map((s) => s.trim());
      const regions = data.region.split(',').map((s) => s.trim());
      let tempIndex = 0;

      // not counting national project
      if (data.isNational == 'Yes') {
        return nationalProjects.push({
          properties: {
            title: data.title,
            link: data.link,
            'sub-title': data.sub_title,
            summary: data.summary,
            thumbnail: data.thumbnail,
            isNational: data.isNational,
            isIdentified: data.isIdentified,
            sector: data.sector,
            priority: data.priority,
            ipl_type: data.ipl_type,
            ipl_new_type: data.field_ipl_map_type,
            category: data.field_map_sector
          },
        });
      }

      // not counting the project not in the list view
      if (hiddenIdFilteredResult.length != dataSize){
        if(jQuery.inArray(Number(data.nid), hiddenIdFilteredResult) === -1){
          hiddenIdNotInResult.push(data.nid);
                return nationalProjects.push({
                  properties: {
                    title: data.title,
                    link: data.link,
                    'sub-title': data.sub_title,
                    summary: data.summary,
                    thumbnail: data.thumbnail,
                    isNational: data.isNational,
                    isIdentified: data.isIdentified,
                    sector: data.sector,
                    priority: data.priority,
                    ipl_type: data.ipl_type,
                    ipl_new_type: data.field_ipl_map_type,
                    category: data.field_map_sector
                  },
                });
        }
      }

      while (locations.length) {
        const location = locations.splice(0, 2);
        const state = states.splice(0, 1);
        const region = regions.splice(0, 1);
        tempIndex += 1;

        const project = {
          type: 'Feature',
          properties: {
            id: data.nid + '-' + tempIndex,
            title: data.title,
            link: data.link,
            'sub-title': data.sub_title,
            summary: data.summary,
            thumbnail: data.thumbnail,
            isNational: data.isNational,
            isIdentified: data.isIdentified,
            sector: data.sector,
            priority: data.priority,
            ipl_type: data.ipl_type,
            ipl_new_type: data.field_ipl_map_type,
            category: data.field_map_sector,
            state: state,
            region: region,
            proposed_by: data.proposed_by,
            isMainLocation: tempIndex == 1,
          },
          geometry: {
            type: 'Point',
            coordinates: [location[1], location[0]],
          },
        };
        projectsGeojson.features.push(project);
        if (typeof(stateData[state]) !== 'undefined') {
          if (tempIndex == 1) {
            stateData[state] += 1;
          }
        }
      }
    });

    initialProjectsGeojson = JSON.parse(JSON.stringify(projectsGeojson));
    resolve();
  });
});

$(document).ready(function() {
  if (!$('#map').length) {
    return;
  }

  const mapClearAllButton = $('.map-clear-all-button');
  const mapSearchKey = $('#map-search-key');
  const mapSearchIcon = $('#map-search-icon');
  const mapSearchClear = $('#map-search-clear');

  // initialStateData();

  // initial map
  mapboxgl.accessToken =
    'pk.eyJ1IjoiaW5mcmFzdHJ1Y3R1cmVhdXMiLCJhIjoiY2p3OXV2eWZ2MDM5cjN5bjB3bWc0bXI1ZyJ9.QlCahvtwYKsE1XyNe8D6fw';
  const map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/infrastructureaus/cjwbeuna21wwi1cpdpn2jb4zf',
    bounds: auBounds,
    maxZoom: 14,
  });

  map.addControl(new mapboxgl.NavigationControl(), 'bottom-left');

  map.on('load', function() {
    // wait until get map content data
    getMapJsonData.then(function() {
      if (isOnMobile) {
        map.setZoom(map.getZoom() + 0.3);
      }
      stateZoomThreshold = map.getZoom() + 0.1;
      addStatePopups();
      setMapMaxBounds();

      const viewProjectId = window.location.href.split('id=')[1];
      if (viewProjectId && performance.navigation.type != 1) {
        // only zoom into project when page first load
        zoomInToProject(viewProjectId);
      }

      map.on('zoomend', function() {
        if (mapFirstLoad == 0 && !isOnMobile) {
          $('html, body').animate(
            {
              scrollTop: $('#ipl-map').offset().top,
            },
            800
          );
          mapFirstLoad++;
        }
      });

      map.on('zoom', function() {
        if (map.getZoom() > stateZoomThreshold) {
          hideStatePopup();
        } else {
          showStatePopup();
        }
      });

      map.addSource('projects', {
        type: 'geojson',
        data: projectsGeojson,
        cluster: true,
        clusterMaxZoom: 14,
        clusterRadius: 80,
        clusterProperties: {
          projectsNo: [
            '+',
            1,
            //['case', ['==', ['get', 'isMainLocation'], true], 1, 0],
          ],
        },
      });

      map.addLayer({
        id: 'clusters',
        type: 'circle',
        source: 'projects',
        minzoom: stateZoomThreshold,
        filter: [
          'all',
          ['has', 'point_count'],
          ['>', ['get', 'projectsNo'], 0],
        ],
        paint: {
          'circle-color': '#005670',
          'circle-opacity': 0.3,
          'circle-radius': 30,
        },
      });

      map.addLayer({
        id: 'cluster-count',
        type: 'symbol',
        source: 'projects',
        minzoom: stateZoomThreshold,
        filter: [
          'all',
          ['has', 'point_count'],
          ['>', ['get', 'projectsNo'], 0],
        ],
        layout: {
          'text-field': ['number-format', ['get', 'projectsNo'], {}],
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12,
        },
      });

      map.addLayer({
        id: 'single-clustered-circle',
        type: 'circle',
        source: 'projects',
        filter: ['==', ['to-boolean', ['get', 'isMainLocation']], true],
        minzoom: stateZoomThreshold,
        maxzoom: singleClusterZoomThreshold,
        paint: {
          'circle-color': '#005670',
          'circle-opacity': 0.3,
          'circle-radius': 30,
        },
      });

      map.addLayer({
        id: 'single-clustered-count',
        type: 'symbol',
        source: 'projects',
        minzoom: stateZoomThreshold,
        maxzoom: singleClusterZoomThreshold,
        filter: ['==', ['to-boolean', ['get', 'isMainLocation']], true],
        layout: {
          'text-field': '1',
          'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
          'text-size': 12,
        },
      });

      map.addLayer({
        id: 'unclustered-point',
        type: 'circle',
        source: 'projects',
        filter: ['!has', 'point_count'],
        minzoom: singleClusterZoomThreshold,
        paint: {
          'circle-color': '#005670',
          'circle-radius': 5,
        },
      });

      map.addSource('cluster-leaves', {
        type: 'geojson',
        data: clusterLeavesGeojson,
      });

      map.addLayer({
        id: 'cluster-leaves-point',
        type: 'circle',
        source: 'cluster-leaves',
        paint: {
          'circle-color': '#005670',
          'circle-radius': 5,
        },
      });

      map.on('data', function(e) {
        if (e.sourceId !== 'projects' || !e.isSourceLoaded) return;
        map.on('move', updateProjectPopups);
        map.on('moveend', updateProjectPopups);
        updateProjectPopups();
        addStatePopups();
      });

      map
        .on('click', collapseClusterLeaves)
        .on('zoomstart', collapseClusterLeaves)
        .on('movestart', collapseClusterLeaves)
        .on('dragstart', collapseClusterLeaves)
        .on('touchstart', collapseClusterLeaves);

      map.on('click', 'clusters', function(e) {
        const features = map.queryRenderedFeatures(e.point, {
          layers: ['clusters'],
        });
        const clusterId = features[0].properties.cluster_id;
        map
          .getSource('projects')
          .getClusterExpansionZoom(clusterId, function(err, zoom) {
            if (err) {
              return;
            }

            if (map.getZoom() < 14) {
              zoom = zoom - map.getZoom() > 2 ? zoom : map.getZoom() + 2;
              const zoomLevel = zoom > 14 ? 14 : zoom;
              map.easeTo({
                center: features[0].geometry.coordinates,
                zoom: zoomLevel,
                easing(t) {
                  return t;
                },
              });
              setTimeout(updateProjectPopups, 1000);
            } else {
              expandClusterLeaves(clusterId);
            }
          });
      });

      map.on('click', 'single-clustered-circle', function(e) {
        map.flyTo({
          center: e.lngLat,
          zoom: singleClusterZoomThreshold + 0.1,
          speed: 0.6,
        });
      });

      map.on('mouseenter', 'clusters', function() {
        map.getCanvas().style.cursor = 'pointer';
      });
      map.on('mouseleave', 'clusters', function() {
        map.getCanvas().style.cursor = '';
      });
      map.on('mouseenter', 'single-clustered-circle', function() {
        map.getCanvas().style.cursor = 'pointer';
      });
      map.on('mouseleave', 'single-clustered-circle', function() {
        map.getCanvas().style.cursor = '';
      });

      detailPopup.on('close', function() {
        map.flyTo({
          center: previousMapCenter,
          zoom: previousMapZoom,
          speed: 0.6,
        });
        map.setFilter('unclustered-point', ['!has', 'point_count']);
        $('.map-view')
          .find('.map-display-options, .map-search')
          .show();
      });

      // mapSearchKey.keyup(function(e) {
      //   if (e.which == 13) {
      //     updateSourceBySearchAndFilter();
      //   }

      //   if (mapSearchKey.val()) {
      //     mapSearchKey.addClass('hasValue');
      //   } else {
      //     mapSearchKey.removeClass('hasValue');
      //     updateSourceBySearchAndFilter();
      //   }
      //   updateMapViewClearAllButtonStatus();
      // });

      // mapSearchIcon.on('click', function() {
      //   updateSourceBySearchAndFilter();
      // });

      // mapSearchClear.on('click', function() {
      //   mapSearchKey.val('');
      //   mapSearchKey.removeClass('hasValue');
      //   updateSourceBySearchAndFilter();
      // });

      $('.map-filter li.facet-item, .map-filter .identified-checkbox').on(
        'click',
        'label',
        function(e) {
          if ($('.ipl-map').attr('data-tab') == 'map-view') {
            // updateSourceBySearchAndFilter();
          }
        }
      );

      // mapClearAllButton.on('click', function() {
      //   if (
      //     $('.ipl-map').attr('data-tab') == 'map-view' &&
      //     $(this)
      //       .find('input')
      //       .attr('disabled') != 'disabled'
      //   ) {
      //     $('.map-filter input.facets-checkbox[checked="checked"]').removeAttr(
      //       'checked'
      //     );
      //     mapSearchKey.val('');
      //     mapSearchKey.removeClass('hasValue');
      //     updateSourceBySearchAndFilter();

      //     map.flyTo({
      //       center: auCenter,
      //       zoom: stateZoomThreshold - 0.1,
      //       speed: 2,
      //       curve: 1,
      //       easing(t) {
      //         return t;
      //       },
      //     });
      //   }
      // });


          $('.ipl-map #tab2').on('click', function() {
            map.resize();
            addStatePopups();



            // if (!projectsGeojson.features.length) {
            //   mapSearchKey.val('');
            // }
            // updateSourceBySearchAndFilter();
      });

      $('#reset-all').on('click', function() {
        map.resize();
        addStatePopups();
      });

      
      $('#edit-submit-ipl-database-search--2').on('click', function() {
        map.resize();
        addStatePopups();
      });


      let allSelectedFilter = '';
      $('li.facet-item input.facets-checkbox').each(function() {
        if ($(this).attr('checked') == 'checked') {
          const filterValue = $(this)
            .next()
            .find('span')
            .text();
          allSelectedFilter == ''
            ? (allSelectedFilter += filterValue)
            : (allSelectedFilter += ', ' + filterValue);
        }
      });
      if (allSelectedFilter !== '') {
         map.resize();
         addStatePopups();
      }

      });
            
      addStatePopups();
      let mapVisibility = $('.map-view').attr('aria-hidden');
      if (mapVisibility === 'true'){
        $('.map-view').css("display","none");
      }else{
        $('.map-view').css("display","block");

      }

  });


  function expandClusterLeaves(clusterId) {
    map
      .getSource('projects')
      .getClusterLeaves(clusterId, 10, 0, function(err, features) {
        if (err) {
          return;
        }

        const circle = turf.circle(features[0].geometry.coordinates, 0.35, {
          steps: features.length < 4 ? 4 : features.length,
          units: 'kilometers',
        });
        features.forEach(function(item, index) {
          const circleCoords = circle.geometry.coordinates[0];
          item.geometry.coordinates = circleCoords[index];
        });
        clusterLeavesGeojson.features = features;
        map.getSource('cluster-leaves').setData(clusterLeavesGeojson);
        isClusterLeavesExpanded = true;
        map.setFilter('clusters', [
          'all',
          ['has', 'point_count'],
          ['!=', ['get', 'cluster_id'], clusterId],
        ]);
        map.setFilter('cluster-count', [
          'all',
          ['has', 'point_count'],
          ['!=', ['get', 'cluster_id'], clusterId],
        ]);
      });
  }

  function collapseClusterLeaves() {
    if (isClusterLeavesExpanded == true) {
      clusterLeavesGeojson.features = [];
      map.getSource('cluster-leaves').setData(clusterLeavesGeojson);
      isClusterLeavesExpanded = false;
      map.setFilter('clusters', ['has', 'point_count']);
      map.setFilter('cluster-count', ['has', 'point_count']);
    }
  }

  function setMapMaxBounds() {
    const mapbound = map.getBounds().toArray();
    if (mapbound[1][0] - mapbound[0][0] > mapbound[1][1] - mapbound[0][1]) {
      // map width > height
      mapbound[1][1] += 3;
      mapbound[0][1] -= 3;
    } else {
      mapbound[1][0] += 6;
      mapbound[0][0] -= 6;
    }
    map.setMaxBounds(mapbound);
  }

  function updateSourceBySearchAndFilter() {
    updateMapViewClearAllButtonStatus();

    detailPopup.remove();
    const searchKeyword = normalize(mapSearchKey.val());
    const identifiedValue =
      $('.map-filter .identified-checkbox input').attr('checked') == 'checked'
        ? 'Yes'
        : 'No';
    const filterData = {
      state: [],
      region: [],
      sector: [],
    };
    $('.map-filter li.facet-item input.facets-checkbox').each(function() {
      if ($(this).attr('checked') == 'checked') {
        const filterValue = $(this)
          .next()
          .find('span')
          .text()
          .toLowerCase();
        filterData[$(this).attr('data-filter')].push(filterValue);
      }
    });
    resetSource();

    projectsGeojson.features = projectsGeojson.features.filter(function(
      feature
    ) {
      const sector = normalize(feature.properties.sector);
      const isInSector =
        filterData.sector.length == 0 || filterData.sector.includes(sector);
      const isIdentified =
        identifiedValue == 'No' ||
        feature.properties.isIdentified == identifiedValue;

      if (searchKeyword.length) {
        const searchExp = new RegExp(
          `\\b(${escapeRegExp(normalize(searchKeyword))})\\b`,
          'gim'
        );
        const title = normalize(feature.properties.title);
        const containTitle = searchExp.test(title);
        const summary = normalize(feature.properties.summary);
        const containSummary = searchExp.test(summary);
        const projectType = normalize(
          `${feature.properties.priority} ${feature.properties.ipl_type}`
        );
        const containsProjectType = searchExp.test(projectType);
        return (
          isInSector &&
          isIdentified &&
          (containTitle || containSummary || containsProjectType)
        );
      } else {
        return isInSector && isIdentified;
      }
    });

    const hasNational = nationalProjects.filter(function(feature) {
      const sector = normalize(feature.properties.sector);
      const isInSector =
        filterData.sector.length == 0 || filterData.sector.includes(sector);
      const isIdentified =
        identifiedValue == 'No' ||
        feature.properties.isIdentified == identifiedValue;

      if (searchKeyword.length) {
        const searchExp = new RegExp(
          `\\b(${escapeRegExp(normalize(searchKeyword))})\\b`,
          'gim'
        );
        const title = normalize(feature.properties.title);
        const containTitle = searchExp.test(title);
        const summary = normalize(feature.properties.summary);
        const containSummary = searchExp.test(summary);
        const projectType = normalize(
          `${feature.properties.priority} ${feature.properties.ipl_type}`
        );
        const containsProjectType = searchExp.test(projectType);
        return (
          isInSector &&
          isIdentified &&
          (containTitle || containSummary || containsProjectType)
        );
      } else {
        return isInSector && isIdentified;
      }
    }).length;

    if (hasNational && !projectsGeojson.features.length) {
      $('.ipl-map #tab1').click();
      $('.state-filter input[data-value="national"]')
        .next()
        .click();
    }

    map.getSource('projects').setData(projectsGeojson);

    updateStatePopup();
    fitAllFilteredProjects();
  }

  function updateMapViewClearAllButtonStatus() {
    if (
      $('.map-filter input.facets-checkbox[checked="checked"]').length ||
      mapSearchKey.val()
    ) {
      // mapClearAllButton.find('input').removeAttr('disabled');
    } else {
      // mapClearAllButton.find('input').attr('disabled', 'disabled');
    }
  }

  function fitAllFilteredProjects() {
    const filteredProjectCoords = [];
    projectsGeojson.features.forEach(function(item, index) {
      filteredProjectCoords.push(item.geometry.coordinates);
    });
    if (filteredProjectCoords.length) {
      const mapBounds = filteredProjectCoords.reduce(function(
        mapBounds,
        coord
      ) {
        return mapBounds.extend(coord);
      },
      new mapboxgl.LngLatBounds(filteredProjectCoords[0], filteredProjectCoords[0]));
      map.fitBounds(mapBounds, {
        padding: { top: 160, bottom: 60, left: 50, right: 50 },
        maxZoom: 12,
        easing(t) {
          return t;
        },
      });
    } else {
      map.flyTo();
    }
  }

  function resetSource() {
    projectsGeojson = JSON.parse(JSON.stringify(initialProjectsGeojson));
    map.getSource('projects').setData(projectsGeojson);
  }

  function updateStatePopup() {
    initialStateData();
    projectsGeojson.features.forEach(function(item, index) {
      const data = item.properties;
      if (data.isMainLocation) {
        if (typeof(stateData[data.state]) !== 'undefined') {
          stateData[data.state][data.ipl_type] += 1;
        }
      }
    });
    hideStatePopup();
    addStatePopups();
  }

  function hideStatePopup() {
    for (const item in stateData) {
      statePopups[item].remove();
    }
  }

  function showStatePopup() {
    for (const item in stateData) {
      statePopups[item].addTo(map);
    }
  }

  function addStatePopups() {
    for (const item in stateData) {
      const coords = stateCentroids[item];
      const statePopupEl = document.createElement('div');
      if (!isOnMobile) {
        const totalNumber =stateData[item];
        const projectHtml = stateData[item].Project
          ? '<span>' + stateData[item].Project + ' projects</span>'
          : '';
        const initiativeHtml = stateData[item].Initiative
          ? '<span>' + stateData[item].Initiative + ' initiatives</span>'
          : '';
        const divider =  stateData[item] ? ' | ' : '';
        statePopupEl.innerHTML =
          '<div class="state blue-style">' +
          abbreviations[item] +
          '</div><div class="seperate-number grey-style">' +
          (stateData[item]) +
          ' proposals</div>';
      } else {
        const totalNumber =stateData[item];
        statePopupEl.innerHTML =
          '<div class="state blue-style">' +
          item +
          '</div><div class="total-number blue-style">' +
          totalNumber +
          '</div>';
      }

      statePopupEl.addEventListener('click', function() {
        map.flyTo({
          center: coords,
          zoom: stateZoomThreshold + 1,
          speed: 0.6,
        });
        $(this).removeClass('hovered');
      });

      const statepopup = (statePopups[item] = new mapboxgl.Popup({
        anchor: 'bottom',
        closeButton: false,
        closeOnClick: false,
        className: 'state-popup',
        maxWidth: '300px',
      })
        .setLngLat(coords)
        .setDOMContent(statePopupEl));
    }
    if (map.getZoom() <= stateZoomThreshold) {
      showStatePopup();
    }
  }

  function updateProjectPopups() {
    const newProjectPopups = {};
    let features = map.queryRenderedFeatures({ layers: ['unclustered-point'] });
    features = features.concat(
      map.queryRenderedFeatures({ layers: ['cluster-leaves-point'] })
    );

    for (let i = 0; i < features.length; i++) {
      const coords = features[i].geometry.coordinates;
      const props = features[i].properties;
      var id = props.id;
      let popup = projectPopups[id];

      if (!popup) {
        const projectPopupEl = document.createElement('div');
        projectPopupEl.innerHTML =
          '<div class="ipl-title blue-style ' +
          props.ipl_type +
          '">' +
          props.title +
          '</div>';

        projectPopupEl.addEventListener('click', function() {
          appendDetailPopup(features[i]);
        });
        projectPopupEl.addEventListener('mouseover', function() {
          $(this)
            .closest('.project-popup')
            .toggleClass('front');
        });
        projectPopupEl.addEventListener('mouseout', function() {
          $(this)
            .closest('.project-popup')
            .toggleClass('front');
        });

        popup = projectPopups[id] = new mapboxgl.Popup({
          anchor: 'bottom',
          closeButton: false,
          closeOnClick: false,
          offset: {
            bottom: [0, -4],
          },
          className: 'project-popup',
          maxWidth: '150px',
        })
          .setLngLat([coords[0], coords[1]])
          .setDOMContent(projectPopupEl);
      }
      newProjectPopups[id] = popup;

      if (!projectPopupsOnScreen[id]) {
        popup.addTo(map);
      }
    }

    for (id in projectPopupsOnScreen) {
      if (!newProjectPopups[id]) {
        projectPopupsOnScreen[id].remove();
      }
    }
    projectPopupsOnScreen = newProjectPopups;
  }

  function appendDetailPopup(features) {
    previousMapCenter = map.getCenter();
    previousMapZoom = map.getZoom();
    const coords = features.geometry.coordinates;
    const props = features.properties;

    const detailPopupEl = document.createElement('div');
    detailPopupEl.className = 'popup-content';
    let subTitleHTML = '';
    if (props.sub_title) {
      subTitleHTML = '<h3 class="detail-subtitle">' + props.sub_title + '</h3>';
    }
    detailPopupEl.innerHTML = `<div class="detail-left">
      <h2 class="detail-title">${props.title}</h2>
      ${subTitleHTML}
      <div class="detail-type priority-type--${props.priority
        .toLowerCase()
        .replace(' ', '-')}-${props.ipl_type.toLowerCase()}">
        ${props.ipl_new_type}
      </div>
      <div class="detail-section">
        <span class="black-title">Outcome Category</span>
        <div>${props.category}</div>
      </div>
      <div class="detail-section">
        <span class="black-title">Proposed by</span>
        <div>${props.proposed_by}</div>
      </div>
      <div class="detail-section detail-section-last">
        <span class="black-title">Summary</span>
        <div>${props.summary}</div>
      </div>
      <div class="detail-go">
        <a class="detail-go-link" href="${props.link}">See full details</a>
      </div>
    </div>
    <div class="detail-right">${props.thumbnail}</div>`;

    detailPopup
      .setLngLat(coords)
      .setDOMContent(detailPopupEl)
      .addTo(map);

    let flyOffset;
    const detailPopupHeight = $(
      '.detail-popup .mapboxgl-popup-content'
    ).height();
    flyOffset = [0, detailPopupHeight / 2];

    map.flyTo({
      center: [coords[0], coords[1]],
      offset: flyOffset,
      zoom: map.getZoom() + 1,
      speed: 0.6,
    });

    $('.map-view')
      .find('.map-display-options, .map-search')
      .hide();

    map.setFilter('unclustered-point', [
      '==',
      ['get', 'id'],
      features.properties.id,
    ]);
  }

  function zoomInToProject(projectId) {
    projectsGeojson.features.forEach(function(item, index) {
      if (item.properties.id == projectId + '-1') {
        map.flyTo({
          center: item.geometry.coordinates,
          zoom: 10,
          speed: 2.2,
          curve: 1,
          easing(t) {
            return t;
          },
        });
      }
    });
  }

  function initialStateData() {
    for (const item in stateData) {
      stateData[item] = 0;
    }
  }
});
